import { Base } from "./base";

export class Card extends Base {
    CardID?: string;
    CardTypeID?: number;
    CardNo?: string;
    ExpireDate?: Date;
    HolderName?: string;
    Token?: string;
    TokenExpireDate?: Date;

    // Web properties
    CardType?: string;
}